import { algos, chartOhlc, setAuthorizationHeader } from '../../api';
import {
  FETCH_PNL_CHART_DATA_REQUEST,
  FETCH_PNL_CHART_DATA_SUCCESS,
  FETCH_PNL_CHART_DATA_FAILURE,
  PNL_CHART_RESET,
  UPDATE_PNL_CHART_FETCH_OPTIONS,
  UPDATE_PNL_CHART_CALC_OPTIONS,
  SELECT_PNL_CHART_CLIENT_ID_DATA,
  UPDATE_PNL_CHART_CLIENT_ID_FILTER_SEARCH,
  UPDATE_PNL_CHART_CLIENT_ID_CACHE,
  UPDATE_PNL_CHART_ALGO_CACHE,
  SELECT_PNL_CHART_ALGO_DATA,
  UPDATE_PNL_CHART_ALGO_FILTER_SEARCH,
  UPDATE_PNL_CHART_ALGO_FILTER_BROKER,
  PNL_CHART_DATA_RESET,
  FETCH_PNL_CHART_NEXT_DATA_SUCCESS,
  EMIT,
  FETCH_PNL_CHART_UNDERLYING_DATA_REQUEST,
  FETCH_PNL_CHART_UNDERLYING_DATA_SUCCESS,
  FETCH_PNL_CHART_UNDERLYING_DATA_FAILURE,
  PNL_CHART_UNDERLYING_DATA_RESET,
  FETCH_PNL_CHART_CLIENT_ID_LIST_REQUEST,
  FETCH_PNL_CHART_CLIENT_ID_LIST_SUCCESS,
  FETCH_PNL_CHART_CLIENT_ID_LIST_FAILURE,
  PNL_CHART_CHART_CLIENT_ID_LIST_RESET,
  FETCH_PNL_CHART_ALGO_LIST_REQUEST,
  FETCH_PNL_CHART_ALGO_LIST_SUCCESS,
  FETCH_PNL_CHART_ALGO_LIST_FAILURE,
  PNL_CHART_CHART_ALGO_LIST_RESET,
  CHART_PNL_LIVE_FEED,
  CHART_UNDERLYINNG_PNL_LIVE_FEED,
  CHART_PNL_UPDATE_LAST_VALUE,
  FETCH_PNL_CHART_UNDERLYING_NEXT_DATA_SUCCESS,
} from '../../constants/ActionTypes';
import { timeoutPromise } from '../../helpers/promises';
import storage from '../../storage';
import {
  getPnlCalcOptions,
  getPnlChartAlgoListData,
  getPnlChartAlgoListFilters,
  getPnlChartClientIdListData,
  getPnlChartClientIdListFilters,
  getPnlChartIsDataFetching,
  getPnlChartIsClientIdListFetching,
  getPnlFetchOptions,
  getPnlChartDataPaging,
  getPnlChartIsUnderlyingDataFetching,
  getPnlChartUnderlyingDataPaging,
  getPnlChartClientIdListcached,
  getPnlChartDataGraphLevel,
  getPnlChartDataFilterList,
  getPnlChartIsAlgoListFetching,
  getPnlChartAlgoListcached,
  getPnlChartQuery,
} from './getters';
import { getPnlChartSearchParams, setPnlChartSearchParams } from './reducers';
import { getIsBrokers, getIsBrokersList } from '../../reducers';
import { textAllCleaner } from '../../helpers/text-cleaner';
import { clearAllChartPoints } from '../chart-store/actions';
import { compareArraysFast } from '../../helpers/compare-array';
import { errorHandler } from '../../helpers/error-handler';

export const subscribePnlGraphUpdate = () => ({
  type: EMIT,
  payload: {
    method: 'subscribe_pnl_graph_update',
    data: {},
  },
});

export const unsubscribePnlGraphUpdate = () => ({
  type: EMIT,
  payload: {
    method: 'unsubscribe_pnl_graph_update',
    data: {},
  },
});

export const fetchNextPnlChartData = () => async (dispatch, getState) => {
  try {
    if (getPnlChartIsDataFetching(getState())) {
      return Promise.resolve();
    }

    setAuthorizationHeader(storage.getItem('token'));

    const fetchOptions = getPnlFetchOptions(getState());
    const [fromdate, toDate] = fetchOptions.date.split('_');

    const { after = null } = getPnlChartDataPaging(getState()) || {};

    if (!after) {
      return Promise.resolve();
    }

    dispatch({
      type: FETCH_PNL_CHART_DATA_REQUEST,
    });

    const graphLevel = getPnlChartDataGraphLevel(getState());
    const filterList = getPnlChartDataFilterList(getState());

    let data = undefined;

    if (graphLevel === 'account') {
      data = await chartOhlc.getAccountLevelData(fromdate, toDate, after);
    } else if (graphLevel === 'broker' && filterList.length) {
      data = await chartOhlc.getBrokerLevelData(
        filterList,
        fromdate,
        toDate,
        after
      );
    } else if (graphLevel === 'algo' && filterList.length) {
      data = await chartOhlc.getAlgoLevelData(
        filterList,
        fromdate,
        toDate,
        after
      );
    }

    if (!data) {
      return Promise.resolve();
    }

    dispatch({
      type: FETCH_PNL_CHART_NEXT_DATA_SUCCESS,
      data,
    });

    return Promise.resolve();
  } catch (error) {
    dispatch({
      type: FETCH_PNL_CHART_DATA_FAILURE,
      data: {
        error,
      },
    });

    const processedError = errorHandler(error);

    return Promise.reject(processedError);
  }
};

export const resetPnlChartData = () => async (dispatch) => {
  dispatch({
    type: PNL_CHART_DATA_RESET,
  });

  return Promise.resolve();
};

//
export const subscribePnlUnderlyingGraphUpdate = (underlying) => ({
  type: EMIT,
  payload: {
    method: 'subscribe_underlying_pnl_graph_update',
    data: {
      underlyingName: underlying,
    },
  },
});

export const unsubscribePnlUnderlyingGraphUpdate = (underlying) => ({
  type: EMIT,
  payload: {
    method: 'unsubscribe_underlying_pnl_graph_update',
    data: {
      underlyingName: underlying,
    },
  },
});

export const fetchPnlChartUnderlyingData =
  (underlying) => async (dispatch, getState) => {
    try {
      if (getPnlChartIsUnderlyingDataFetching(getState())) {
        return Promise.resolve();
      }

      setAuthorizationHeader(storage.getItem('token'));

      const fetchOptions = getPnlFetchOptions(getState());
      const [fromdate, toDate] = fetchOptions.date.split('_');

      dispatch({
        type: FETCH_PNL_CHART_UNDERLYING_DATA_REQUEST,
      });

      const data = await chartOhlc.getUnderlyingData(
        underlying,
        fromdate,
        toDate
      );

      dispatch({
        type: FETCH_PNL_CHART_UNDERLYING_DATA_SUCCESS,
        data,
        underlying,
      });

      await timeoutPromise(100);

      return Promise.resolve();
    } catch (error) {
      dispatch({
        type: FETCH_PNL_CHART_UNDERLYING_DATA_FAILURE,
        data: {
          error,
        },
      });

      const processedError = errorHandler(error);

      return Promise.reject(processedError);
    }
  };

export const fetchNextPnlChartUnderlyingData =
  () => async (dispatch, getState) => {
    try {
      if (getPnlChartIsUnderlyingDataFetching(getState())) {
        return Promise.resolve();
      }

      setAuthorizationHeader(storage.getItem('token'));
      const calcOptions = getPnlCalcOptions(getState());
      const underlying = calcOptions.underlying;

      if (!underlying) {
        return Promise.resolve();
      }

      const fetchOptions = getPnlFetchOptions(getState());
      const [fromdate, toDate] = fetchOptions.date.split('_');

      const { after = null } =
        getPnlChartUnderlyingDataPaging(getState()) || {};

      if (!after) {
        return Promise.resolve();
      }

      dispatch({
        type: FETCH_PNL_CHART_UNDERLYING_DATA_REQUEST,
      });

      const data = await chartOhlc.getUnderlyingData(
        underlying,
        fromdate,
        toDate,
        after
      );

      dispatch({
        type: FETCH_PNL_CHART_UNDERLYING_NEXT_DATA_SUCCESS,
        data,
        underlying,
      });

      return Promise.resolve();
    } catch (error) {
      dispatch({
        type: FETCH_PNL_CHART_UNDERLYING_DATA_FAILURE,
        data: {
          error,
        },
      });

      const processedError = errorHandler(error);

      return Promise.reject(processedError);
    }
  };

export const resetPnlChartUnderlyingData = () => async (dispatch) => {
  dispatch({
    type: PNL_CHART_UNDERLYING_DATA_RESET,
  });

  return Promise.resolve();
};
//

export const fetchPnlChartAccountData = () => async (dispatch, getState) => {
  try {
    if (getPnlChartIsDataFetching(getState())) {
      return Promise.resolve();
    }

    setAuthorizationHeader(storage.getItem('token'));
    const fetchOptions = getPnlFetchOptions(getState());
    const [fromdate, toDate] = fetchOptions.date.split('_');

    dispatch({
      type: FETCH_PNL_CHART_DATA_REQUEST,
    });

    const data = await chartOhlc.getAccountLevelData(fromdate, toDate);

    const pnlFetchOptions = getPnlFetchOptions(getState());

    dispatch({
      type: FETCH_PNL_CHART_DATA_SUCCESS,
      data,
      graphLevel: 'account',
      filterList: [],
      query: pnlFetchOptions,
    });

    await timeoutPromise(100);

    return Promise.resolve();
  } catch (error) {
    dispatch({
      type: FETCH_PNL_CHART_DATA_FAILURE,
      data: {
        error,
      },
    });

    const processedError = errorHandler(error);

    return Promise.reject(processedError);
  }
};

export const updateClientIdCachedData =
  (initialData) => async (dispatch, getState) => {
    const fullData = initialData || getPnlChartClientIdListData(getState());
    const brokerListData = getIsBrokersList(getState());

    const filters = getPnlChartClientIdListFilters(getState());
    const search = textAllCleaner(filters.search);

    dispatch(clearAllChartPoints());

    if (!search) {
      dispatch({
        type: UPDATE_PNL_CHART_CLIENT_ID_CACHE,
        data: fullData,
      });

      return Promise.resolve();
    }

    const newData = [];

    for (let index = 0; index < fullData.length; index++) {
      const element = fullData[index];

      const displayName =
        brokerListData.find((item) => item.name === element.name)
          ?.displayName || '';

      const displayNameClean = textAllCleaner(displayName);

      if (displayNameClean.includes(search)) {
        newData.push(element);
        continue;
      }

      const clientIdClean = textAllCleaner(element.clientId);

      if (clientIdClean.includes(search)) {
        newData.push(element);
        continue;
      }
    }

    dispatch({
      type: UPDATE_PNL_CHART_CLIENT_ID_CACHE,
      data: newData,
    });

    return Promise.resolve();
  };

export const fetchPnlChartClientIdList = () => async (dispatch, getState) => {
  try {
    if (getPnlChartIsClientIdListFetching(getState())) {
      return Promise.resolve();
    }

    setAuthorizationHeader(storage.getItem('token'));

    const brokersData = getIsBrokers(getState());

    dispatch({
      type: FETCH_PNL_CHART_CLIENT_ID_LIST_REQUEST,
    });

    const { broker = [] } = getPnlChartSearchParams(window.location);

    const data = brokersData.map((bd) => {
      const selected = broker.includes(bd.id);

      return Object.assign({
        ...bd,
        selected,
      });
    });

    dispatch({
      type: FETCH_PNL_CHART_CLIENT_ID_LIST_SUCCESS,
      data,
    });

    dispatch(updateClientIdCachedData(data));

    await timeoutPromise(100);

    return Promise.resolve();
  } catch (error) {
    dispatch({
      type: FETCH_PNL_CHART_CLIENT_ID_LIST_FAILURE,
      data: {
        error,
      },
    });

    return Promise.reject(null);
  }
};

export const selectClientIdData =
  (id, select = false) =>
  async (dispatch) => {
    dispatch({
      type: SELECT_PNL_CHART_CLIENT_ID_DATA,
      id,
      select,
    });

    return Promise.resolve();
  };

export const updateClientIdFilterSearch = (searchTerm) => async (dispatch) => {
  dispatch({
    type: UPDATE_PNL_CHART_CLIENT_ID_FILTER_SEARCH,
    data: searchTerm,
  });

  return Promise.resolve();
};

export const resetPnlChartClientIdList = () => async (dispatch) => {
  dispatch({
    type: PNL_CHART_CHART_CLIENT_ID_LIST_RESET,
  });

  return Promise.resolve();
};

export const fetchPnlChartBrokerData = () => async (dispatch, getState) => {
  try {
    if (getPnlChartIsDataFetching(getState())) {
      return Promise.resolve();
    }

    setAuthorizationHeader(storage.getItem('token'));

    const oldFilterList = getPnlChartDataFilterList(getState()) || [];

    const fetchOptions = getPnlFetchOptions(getState());
    const [fromdate, toDate] = fetchOptions.date.split('_');

    const fullData = getPnlChartClientIdListcached(getState());
    const broker = fullData
      .filter((item) => item.selected)
      .map((item) => `${item.name}:${item.clientId}`);

    if (!broker.length) {
      dispatch({
        type: PNL_CHART_DATA_RESET,
      });

      return Promise.resolve();
    }

    const isSameAlgos = compareArraysFast(oldFilterList, broker);
    const { date: dateOld = '' } = getPnlChartQuery(getState());

    // prevent duplicate calls
    if (isSameAlgos && dateOld === fetchOptions.date) {
      return Promise.resolve();
    }

    dispatch({
      type: FETCH_PNL_CHART_DATA_REQUEST,
    });

    const data = await chartOhlc.getBrokerLevelData(broker, fromdate, toDate);

    const pnlFetchOptions = getPnlFetchOptions(getState());

    dispatch({
      type: FETCH_PNL_CHART_DATA_SUCCESS,
      data,
      graphLevel: 'broker',
      filterList: broker,
      query: pnlFetchOptions,
    });

    await timeoutPromise(100);

    return Promise.resolve();
  } catch (error) {
    dispatch({
      type: FETCH_PNL_CHART_DATA_FAILURE,
      data: {
        error,
      },
    });

    const processedError = errorHandler(error);

    return Promise.reject(processedError);
  }
};

//

export const updateAlgoCachedData =
  (initialData) => async (dispatch, getState) => {
    const fullData = initialData || getPnlChartAlgoListData(getState());

    const filters = getPnlChartAlgoListFilters(getState());
    const search = textAllCleaner(filters.search);
    const broker = filters.broker;

    dispatch(clearAllChartPoints());

    if (!search && !broker) {
      dispatch({
        type: UPDATE_PNL_CHART_ALGO_CACHE,
        data: fullData,
      });

      return Promise.resolve();
    }

    const newData = [];

    for (let index = 0; index < fullData.length; index++) {
      const element = fullData[index];

      if (broker && element.clientId !== broker) {
        continue;
      }

      // no search
      if (!search) {
        newData.push(element);
        continue;
      }

      const nameClean = textAllCleaner(element.name);

      if (nameClean.includes(search)) {
        newData.push(element);
        continue;
      }
    }

    dispatch({
      type: UPDATE_PNL_CHART_ALGO_CACHE,
      data: newData,
    });

    return Promise.resolve();
  };

export const fetchPnlChartAlgoData = () => async (dispatch, getState) => {
  try {
    if (getPnlChartIsDataFetching(getState())) {
      return Promise.resolve();
    }

    setAuthorizationHeader(storage.getItem('token'));

    const oldFilterList = getPnlChartDataFilterList(getState()) || [];

    const fetchOptions = getPnlFetchOptions(getState());
    const [fromdate, toDate] = fetchOptions.date.split('_');

    const fullData = getPnlChartAlgoListcached(getState());
    const algoIds = fullData
      .filter((item) => item.selected)
      .map((item) => item.id);

    if (!algoIds.length) {
      dispatch({
        type: PNL_CHART_DATA_RESET,
      });

      return Promise.resolve();
    }

    const isSameAlgos = compareArraysFast(oldFilterList, algoIds);
    const { date: dateOld = '' } = getPnlChartQuery(getState());

    // prevent duplicate calls
    if (isSameAlgos && dateOld === fetchOptions.date) {
      return Promise.resolve();
    }

    dispatch({
      type: FETCH_PNL_CHART_DATA_REQUEST,
    });

    const data = await chartOhlc.getAlgoLevelData(algoIds, fromdate, toDate);

    const pnlFetchOptions = getPnlFetchOptions(getState());

    dispatch({
      type: FETCH_PNL_CHART_DATA_SUCCESS,
      data,
      graphLevel: 'algo',
      filterList: algoIds,
      query: pnlFetchOptions,
    });

    await timeoutPromise(100);

    return Promise.resolve();
  } catch (error) {
    dispatch({
      type: FETCH_PNL_CHART_DATA_FAILURE,
      data: {
        error,
      },
    });

    const processedError = errorHandler(error);

    return Promise.reject(processedError);
  }
};

export const fetchPnlChartAlgoList = () => async (dispatch, getState) => {
  try {
    if (getPnlChartIsAlgoListFetching(getState())) {
      return Promise.resolve();
    }

    setAuthorizationHeader(storage.getItem('token'));

    const algosRes = await algos.getAlgos();
    const algosData = algosRes?.data?.data || [];

    const { algo = [] } = getPnlChartSearchParams(window.location);

    const data = algosData
      .map((item) => {
        if (!item.broker) {
          return null;
        }

        const selected = algo.includes(item._id);

        return Object.assign({
          ...item,
          selected,
          id: item._id,
          clientId: item.brokerClientId,
        });
      })
      .filter((n) => n !== null);

    dispatch({
      type: FETCH_PNL_CHART_ALGO_LIST_REQUEST,
    });

    dispatch({
      type: FETCH_PNL_CHART_ALGO_LIST_SUCCESS,
      data,
    });

    dispatch(updateAlgoCachedData(data));

    await timeoutPromise(100);

    return Promise.resolve();
  } catch (error) {
    dispatch({
      type: FETCH_PNL_CHART_ALGO_LIST_FAILURE,
      data: {
        error,
      },
    });

    return Promise.reject(null);
  }
};

export const resetPnlChartAlgoList = () => async (dispatch) => {
  dispatch({
    type: PNL_CHART_CHART_ALGO_LIST_RESET,
  });

  return Promise.resolve();
};

export const selectAlgoData =
  (id, select = false) =>
  async (dispatch) => {
    dispatch({
      type: SELECT_PNL_CHART_ALGO_DATA,
      id,
      select,
    });

    return Promise.resolve();
  };

export const updateAlgoFilterSearch = (searchTerm) => async (dispatch) => {
  dispatch({
    type: UPDATE_PNL_CHART_ALGO_FILTER_SEARCH,
    data: searchTerm,
  });

  return Promise.resolve();
};

export const updateAlgoFilterBroker = (brokerName) => async (dispatch) => {
  dispatch({
    type: UPDATE_PNL_CHART_ALGO_FILTER_BROKER,
    data: brokerName,
  });

  return Promise.resolve();
};

/**
 * Resets the P&L Chart state.
 *
 * @returns {Promise<void>} A promise that resolves immediately after resetting the state.
 */
export const resetPnlChart = () => async (dispatch) => {
  dispatch({
    type: PNL_CHART_RESET,
  });

  return Promise.resolve();
};

const updateParams =
  (data = {}) =>
  async (_dispatch, getState) => {
    const fetchOptions = getPnlFetchOptions(getState());
    const calcOptions = getPnlCalcOptions(getState());

    const paramsAll = {
      ...fetchOptions,
      ...calcOptions,
      ...data,
    };

    setPnlChartSearchParams(paramsAll);

    return Promise.resolve();
  };

export const updateFetchOptions =
  (data = {}) =>
  async (dispatch, getState) => {
    const fetchOptions = getPnlFetchOptions(getState());

    const newFetchOptions = {
      ...fetchOptions,
      ...data,
    };

    dispatch({
      type: UPDATE_PNL_CHART_FETCH_OPTIONS,
      data: newFetchOptions,
    });

    dispatch(updateParams(newFetchOptions));

    return Promise.resolve();
  };

export const updateCalcOptions =
  (data = {}) =>
  async (dispatch, getState) => {
    const calcOptions = getPnlCalcOptions(getState());

    const newCalcOptions = {
      ...calcOptions,
      ...data,
    };

    dispatch({
      type: UPDATE_PNL_CHART_CALC_OPTIONS,
      data: newCalcOptions,
    });

    dispatch(updateParams(newCalcOptions));

    return Promise.resolve();
  };

export const fetchShareLink =
  ({ showAccountName = false }) =>
  async (_dispatch, getState) => {
    try {
      setAuthorizationHeader(storage.getItem('token'));

      const fetchOptions = getPnlFetchOptions(getState());

      const [fromdate, toDate] = fetchOptions.date.split('_');

      const { chartType } = getPnlCalcOptions(getState());

      const graphLevel = getPnlChartDataGraphLevel(getState());
      const filterList = getPnlChartDataFilterList(getState());

      let data = undefined;

      if (graphLevel === 'account') {
        data = await chartOhlc.getAccountLevelShareLink(
          fromdate,
          toDate,
          chartType,
          showAccountName
        );
      } else if (graphLevel === 'broker' && filterList.length) {
        data = await chartOhlc.getClientIdLevelShareLink(
          filterList,
          fromdate,
          toDate,
          chartType,
          showAccountName
        );
      } else if (graphLevel === 'algo' && filterList.length) {
        data = await chartOhlc.getAlgoLevelShareLink(
          filterList,
          fromdate,
          toDate,
          chartType,
          showAccountName
        );
      }

      await timeoutPromise(100);

      if (!data?.data?.data) {
        throw new Error('Share: No data');
      }

      return Promise.resolve(data?.data?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  };

export const fakeLiveUpdate = () => async (dispatch) => {
  dispatch({
    type: CHART_PNL_LIVE_FEED,
    data: `finvasia:FA63360,667941d8809fefea946a7464,${Date.now()},-87.75,-10.5,-129,-10.5`,
  });

  return Promise.resolve();
};

export const fakeUnderlyingLiveUpdate = () => async (dispatch) => {
  dispatch({
    type: CHART_UNDERLYINNG_PNL_LIVE_FEED,
    data: `NIFTY 50,${Date.now()},23567.85,23574.7,23567.25,23573.1`,
  });

  return Promise.resolve();
};

export const updatePnlChartStats = () => async (dispatch) => {
  dispatch({
    type: CHART_PNL_UPDATE_LAST_VALUE,
  });

  return Promise.resolve();
};
